import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css";

export default class CompanyTax extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            isActive: false
        }
    }

    componentDidMount() {
        this.httpPost("api/v1/company/get", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setBodyValue(id, field, value) {
        for (var i = 0; i < this.state.data.record.companyCostos.length; i++) {
            if (this.state.data.record.companyCostos[i].id === id) {

                this.state.data.record.companyCostos[i][field] = value;
            }

        }



        this.setState({ data: this.state.data });
    }

    setBodyValueDetail(id, field, value) {
        for (var i = 0; i < this.state.data.record.companyDetails.length; i++) {
            if (this.state.data.record.companyDetails[i].id === id) {

                this.state.data.record.companyDetails[i][field] = value;
            }

        }



        this.setState({ data: this.state.data });
    }


    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/company/save", {
            record: this.state.data.record

        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/companiestax/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    removeItemHazine(e, id) {
        e.preventDefault();
        var temp = [];
        this.state.data.record.companyCostos.forEach(r => {
            if (r.id != id) temp.push(r);
        });
        this.state.data.record.companyCostos = temp;
        this.setState({ data: this.state.data });
    }
    removeItemDetail(e, id) {
        e.preventDefault();
        var temp = [];
        this.state.data.record.companyDetails.forEach(r => {
            if (r.id != id) temp.push(r);
        });
        this.state.data.record.companyDetails = temp;
        this.setState({ data: this.state.data });
    }
    newRow(e) {
        e.preventDefault();
        this.state.data.record.companyCostos.push({
            id: Math.floor(Math.random() * 100) + 1,
            titleCosto: '',
            codeCosto: '',
            codeKollBimeKarfarma: '',
            codeMoeinBimeKarfarma: '',
            codeKollHBimeBikari: '',
            codeMoeinHBimeBikari: ''

        });
        this.setState({ data: this.state.data });
    }
    newRowDetail(e) {
        e.preventDefault();
        this.state.data.record.companyDetails.push({
            id: Math.floor(Math.random() * 100) + 1,
            typeCompany: '',
            titleCompany: '',
            codeCompany: '',
            postalCodeCompany: '',
            address: '',
            codeHKollMal: '',
            codeHMoeinMal: '',
            codeHTafzilMal: '',
            codeHKollBime: '',
            codeHMoeinBime: '',
            codeHTafzilBime: '',
            perBimeKarfarma: 0,
            perBimeKarmand: 0,
            perBimeBikari: 0


        });
        this.setState({ data: this.state.data });
    }
    change(e) {
        this.state.isActive = e;
        this.setState({ data: this.state.data });
    }
    changeType(type) {
        this.state.data.record.type = type;
        this.setState({ isActive: this.state.isActive });
    }
    handleChange(value) {
        //تغییرات روی تاریخ رو اینجا اعمال کنید
        this.state.data.record.dateStart = value;
        this.setState(this.state.data.record.dateStart = value);
    }
    renderForm() {
        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <NavLink className="back-to" to="/companiestax/"><em className="icon ni ni-arrow-left"></em><span>فهرست مودی</span></NavLink>
                                    </div>
                                </div>
                            </div>

                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="base">
                                                <div className="row g-4">
                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">نوع فعالیت</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" defaultValue={this.state.data.record.type} onChange={e => this.changeType(parseInt(e.target.value))}>
                                                                    <option value="2">حقوقی</option>
                                                                    <option value="1">حقیقی</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-2">
                                                        <div className="form-group">

                                                            <label className="form-label">نام شرکت</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control" type="text" defaultValue={this.state.data.record.companyName} onChange={e => this.state.data.record.companyName = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">نام و نام خانوادگی مدیر عامل</label>
                                                            <div className="form-control-wrap">

                                                                <input className="form-control" type="text" defaultValue={this.state.data.record.fullName} onChange={e => this.state.data.record.fullName = e.target.value} />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-2">
                                                        <div className="form-group">
                                                            <label className="form-label">شناسه ملی</label>
                                                            <div className="form-control-wrap">

                                                                <input className="form-control ltr"  type="text" defaultValue={this.state.data.record.codeMelli} onChange={e => this.state.data.record.codeMelli = e.target.value} />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">آدرس</label>
                                                            <div className="form-control-wrap">

                                                                <textarea className="form-control" type="text" defaultValue={this.state.data.record.address} onChange={e => this.state.data.record.address = e.target.value} ></textarea>

                                                            </div>
                                                        </div>
                                                    </div>    
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <div className="custom-control custom-switch">
                                                                <input type="checkbox" className="custom-control-input" defaultChecked={this.state.isActive} onChange={e => this.change(e.target.checked)} id="customSwitch2" />
                                                                <label className="custom-control-label" htmlFor="customSwitch2">تنظیمات مودیان </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.isActive === true &&
                                                        <div className="col-lg-2">
                                                            <div className="form-group">
                                                                <label className="form-label">شناسه حافظه مالیاتی</label>
                                                                <div className="form-control-wrap">

                                                                    <input className="form-control ltr" maxLength="6" type="text" defaultValue={this.state.data.record.taxUserName} onChange={e => this.state.data.record.taxUserName = e.target.value} />

                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.isActive === true &&
                                                               <div className={this.state.data.record.type === 1 ? "col-lg-6" : "col-lg-8"}>
                                                                <div className="form-group">
                                                                    <label className="form-label">نوع شناسه</label>
                                                                    <div className="form-control-wrap">
                                                                        <select className="form-control" defaultValue={this.state.data.record.isSandbox} onChange={e => this.state.data.record.isSandbox = (e.target.value == 'true' ? true : false)}>
                                                                            <option value="true">شناسه حافظه مربوط به سامانه آزمایشی (سند باکس) است</option>
                                                                            <option value="false">شناسه حافظه از سامانه اصلی مودیان دریافت شده است</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                            
                                                    }
                                                    {this.state.isActive == true &&
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                                <label className="form-label">متن فایل کلید خصوصی</label>
                                                                <div className="form-control-wrap">
                                                         
                                                                    <textarea className="form-control ltr" type="text" defaultValue={this.state.data.record.privateKey} onChange={e => this.state.data.record.privateKey = e.target.value} ></textarea>

                                                                </div>
                                                            </div>
                                                        </div>         
                                                    }


                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ثبت</button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form >
    }
    SetCheckedInInsu(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inInsu = this.state.data.record.inInsu.replace(f, "");
        if (v) this.state.data.record.inInsu += f;
    }
    IsCheckedInsu(f) {
        f = "[" + f + "]";
        return this.state.data.record.inInsu.includes(f);
    }
    SetCheckedInTax(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inTax = this.state.data.record.inTax.replace(f, "");
        if (v) this.state.data.record.inTax += f;
    }
    IsCheckedInTax(f) {
        f = "[" + f + "]";
        return this.state.data.record.inTax.includes(f);
    }
    SetCheckedInReward(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inReward = this.state.data.record.inReward.replace(f, "");
        if (v) this.state.data.record.inReward += f;
    }
    IsCheckedInReward(f) {
        f = "[" + f + "]";
        return this.state.data.record.inReward.includes(f);
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}